var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PanelV2',{attrs:{"type":"w7","title":"Grow your business with cashless payment acceptance!"},on:{"nextClick":function($event){return _vm.next()}},scopedSlots:_vm._u([{key:"content-solt",fn:function(){return [_c('Digital',{attrs:{"digitalData":_vm.formData},on:{"checkboxClick":_vm.checkboxClick}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }